"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var changeCase_1 = require("./changeCase");
var typeChecks_1 = require("./typeChecks");
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
function getComponentCss(cssSelector, componentStyle, props, existingStyles) {
    var response = existingStyles || [];
    if (componentStyle) {
        var conditionals = componentStyle.conditionals;
        addStylesForConditionals(cssSelector, response, conditionals, props);
    }
    if (props && props.componentStyle) {
        getCss(cssSelector, props.componentStyle, props, response);
    }
    return response;
}
exports.getComponentCss = getComponentCss;
function getCss(cssSelector, componentStyle, props, existingStyles, prefix) {
    if (prefix === void 0) { prefix = ''; }
    var response = existingStyles || [];
    if (componentStyle) {
        var breakpoints = componentStyle.breakpoints, selectors = componentStyle.selectors, conditionals = componentStyle.conditionals;
        var exclusionKeys_1 = ['_raw', 'breakpoints', 'selectors', 'conditionals', '_parameters', 'sizes', 'priorities', 'children', 'show', 'overrides', 'arrowDirection', 'chartProps', 'seriesColors', 'selected', 'groupHeader', 'groupChild'];
        var innerCss_1 = [];
        // Loop over the available keys in the theme element object and add the styles for those to the response
        Object.entries(componentStyle).map(function (_a) {
            var key = _a[0], value = _a[1];
            if (exclusionKeys_1.indexOf(key) === -1) {
                addStyleForObjectOrString(innerCss_1, value, changeCase_1.paramCase(key));
            }
        });
        if (componentStyle._raw && !typeChecks_1.isNullOrEmpty(componentStyle._raw)) {
            innerCss_1.push(componentStyle._raw);
        }
        var cleanCss = getCleanStyle(innerCss_1);
        if (cleanCss && cleanCss.length > 0) {
            response.push("" + prefix + cssSelector + " {");
            response.push(prefix + "\t" + cleanCss.join('\n\t'));
            response.push(prefix + "}");
        }
        addStylesForConditionals(cssSelector, response, conditionals, props);
        // Break points happen at the end for any overrides
        addStyleForBreakpoints(cssSelector, response, breakpoints, props);
        // ISelectors (hover etc)
        addStyleForSelectors(cssSelector, response, selectors, props);
        // Overrides for child components
        addStyleOverrides(cssSelector, response, componentStyle, props);
    }
    return getCleanStyle(response).join('\n');
}
exports.getCss = getCss;
function getCleanStyle(collection) {
    return collection.filter(function (value) { return !typeChecks_1.isNullOrEmpty(value); });
}
exports.getCleanStyle = getCleanStyle;
function addStyleForBreakpoints(cssSelector, collection, breakpoints, props) {
    if (breakpoints) {
        for (var _i = 0, breakpoints_1 = breakpoints; _i < breakpoints_1.length; _i++) {
            var breakpoint = breakpoints_1[_i];
            collection.push.apply(collection, getStyleForBreakpoint(cssSelector, breakpoint, props));
        }
    }
}
exports.addStyleForBreakpoints = addStyleForBreakpoints;
function getStyleForBreakpoint(cssSelector, breakpoint, props) {
    var response = [];
    var key = !typeChecks_1.isNullOrUndefined(breakpoint.max) ? 'max' : (!typeChecks_1.isNullOrUndefined(breakpoint.min) ? 'min' : null);
    if (key) {
        var value = breakpoint[key];
        var defaultMedia = ['print', 'screen'];
        var media = breakpoint.media || defaultMedia;
        response.push("@media " + media.join(', ') + " and (" + key + "-width: " + value + ") {");
        getCss(cssSelector, breakpoint.style, props, response, '\t');
        response.push("}");
    }
    return response;
}
exports.getStyleForBreakpoint = getStyleForBreakpoint;
function addStyleForSelectors(cssSelector, collection, selectors, props) {
    var selectorsArray = [];
    if (!typeChecks_1.isNullOrUndefined(selectors)) {
        if (Array.isArray(selectors)) {
            selectorsArray.push.apply(selectorsArray, selectors);
        }
        else {
            selectorsArray.push(selectors);
        }
    }
    for (var _i = 0, selectorsArray_1 = selectorsArray; _i < selectorsArray_1.length; _i++) {
        var selector = selectorsArray_1[_i];
        Object.entries(selector).map(function (_a) {
            var key = _a[0], value = _a[1];
            var workingKey = key;
            if (value['_parameters'] && Array.isArray(value['_parameters'])) {
                workingKey += "(" + value['_parameters'].join(',') + ")";
            }
            var workingCssSelector = "" + cssSelector + workingKey;
            getCss(workingCssSelector, value, props, collection);
        });
    }
}
exports.addStyleForSelectors = addStyleForSelectors;
function addStylesForConditionals(cssSelector, collection, conditionalStyles, props) {
    var conditionalCss = (conditionalStyles || []).reduce(function (acc, conditionalStyle) {
        if (conditionalStyle) {
            var conditional = conditionalStyle.conditional, style = conditionalStyle.style;
            var conditionalHelper = new ConditionalHelper_1.ConditionalHelper(conditional);
            if (conditionalHelper.matches(props)) {
                acc.push(getCss(cssSelector, style, props));
            }
        }
        return acc;
    }, []);
    return collection.push.apply(collection, conditionalCss);
}
function addStyleOverrides(cssSelector, collection, componentStyle, props) {
    if (componentStyle && componentStyle.overrides) {
        for (var _i = 0, _a = componentStyle.overrides; _i < _a.length; _i++) {
            var override = _a[_i];
            var selector = override.selector, style = override.style;
            var childSelector = [cssSelector, selector].join(' ');
            getCss(childSelector, style, props, collection);
        }
    }
}
exports.addStyleOverrides = addStyleOverrides;
function getStyleForObject(styleObject, prefix) {
    var response = [];
    if (!typeChecks_1.isNullOrUndefined(styleObject)) {
        var workingPrefix_1 = prefix && prefix.toLowerCase() === prefix ? prefix : changeCase_1.paramCase(prefix);
        if (!typeChecks_1.isNullOrUndefined(styleObject['_value'])) {
            response.push(workingPrefix_1 + ": " + styleObject['_value'] + ";");
        }
        Object.entries(styleObject).map(function (_a) {
            var key = _a[0], value = _a[1];
            if (!key.startsWith('_') && !typeChecks_1.isNullOrUndefined(value) && value !== '') {
                if (typeChecks_1.isObject(value)) {
                    response.push.apply(response, getStyleForObject(value, workingPrefix_1 + "-" + changeCase_1.paramCase(key)));
                }
                else {
                    response.push(workingPrefix_1 + "-" + changeCase_1.paramCase(key) + ": " + value + ";");
                }
            }
        });
    }
    return response;
}
exports.getStyleForObject = getStyleForObject;
function addStyleForObjectOrString(collection, styleObject, prefix) {
    var workingPrefix = changeCase_1.paramCase(prefix);
    var response = [];
    if (!typeChecks_1.isNullOrUndefined(styleObject)) {
        if (typeChecks_1.isObject(styleObject)) {
            response.push.apply(response, getStyleForObject(styleObject, workingPrefix));
        }
        else {
            response.push(workingPrefix + ": " + styleObject + ";");
        }
        collection.push.apply(collection, response);
    }
    return '';
}
exports.addStyleForObjectOrString = addStyleForObjectOrString;
//# sourceMappingURL=rawComponentStyle.js.map